import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, AlertController, NavParams, IonSearchbar } from '@ionic/angular';
import { PersonService } from './../../services/person.service';
import { ObserverService } from '../../services/observer.service';
import { PersonAddPage } from '../../modals/person-add/person-add.page';

@Component({
    selector: 'app-person-picker',
    templateUrl: './person-picker.page.html',
    styleUrls: ['./person-picker.page.scss'],
})
export class PersonPickerPage implements OnInit {

    @ViewChild('search_bar_input', { static: false }) search_bar_input: IonSearchbar;

    loading = false;
    params = {};
    all_people = null;
    visible_people = null;
    people = null;
    keywords = '';
    person_id = null;
    person = null;
    invoked_from = null;

    constructor(
        public navParams: NavParams,
        public modalController: ModalController,
        public alertController: AlertController,
        private personService: PersonService,
        private observerService: ObserverService,
    ) { }

    ngOnInit() {

        if(this.navParams.get("invoked_from")) {
            this.invoked_from = this.navParams.get("invoked_from");
        }

        if(this.navParams.get('person_id')) {

            this.person_id = this.navParams.get('person_id');

            this.loadPerson(this.person_id).then((person) => {
                if(person) {
                    this.person = person;
                }
            })
            .catch(() => { });

        }

        this.personService.getPeople().then((people) => {
            if(people) {
                this.all_people = people;
            }
        })
        .catch(() => {});

        this.observerService.subscribe('person_added|person_picker_modal', (person) => {
            if(person) {
                this.all_people.push(person);
                let keywords = this.keywords.toLowerCase().trim();
                if(keywords.length) {
                    if(
                        (person.full_name && person.full_name.toLowerCase().includes(keywords)) ||
                        (person.number && person.number.toString().includes(keywords)) ||
                        (person.email_address && person.email_address.toLowerCase().includes(keywords)) ||
                        (person.mobile_phone_number && person.mobile_phone_number.toString().toLowerCase().includes(keywords)) ||
                        (person.work_phone_number && person.work_phone_number.toString().toLowerCase().includes(keywords)) ||
                        (person.home_phone_number && person.home_phone_number.toString().toLowerCase().includes(keywords)) ||
                        (person.organisation?.title && person.organisation?.title.toString().toLowerCase().includes(keywords))
                    ) {
                        let people = this.visible_people;
                        people.push(person)
                        people.sort((a, b) => {
                            if(a['full_name'].toLowerCase() < b['full_name'].toLowerCase()) { return -1; }
                            if(a['full_name'].toLowerCase() > b['full_name'].toLowerCase()) { return 1; }
                            return 0;
                        });
                        this.visible_people = people;
                    }
                }
            }
        });

        this.observerService.subscribe('person_deleted|person_picker_modal', (person) => {
            if(person) {
                if(this.all_people) {
                    for(let i = 0; i < this.all_people.length; i++) {
                        if(this.all_people[i].id === person["id"]) {
                            this.all_people.splice(i, 1);
                            break;
                        }
                    }
                }
                if(this.visible_people) {
                    for(let i = 0; i < this.visible_people.length; i++) {
                        if(this.visible_people[i].id === person["id"]) {
                            this.visible_people.splice(i, 1);
                            break;
                        }
                    }
                }
            }
        });

        this.observerService.subscribe('person_updated|person_picker_modal', (person) => {
            if(person) {
                if(this.all_people) {
                    for(let i = 0; i < this.all_people.length; i++) {
                        if(this.all_people[i].id === person.id) {
                            this.all_people[i] = person;
                            break;
                        }
                    }
                }
                if(this.visible_people) {
                    for(let i = 0; i < this.visible_people.length; i++) {
                        if(this.visible_people[i].id === person["id"]) {
                            this.visible_people.splice(i, 1);
                            let keywords = this.keywords.toLowerCase().trim();
                            if(keywords.length) {
                                if(
                                    (person.full_name && person.full_name.toLowerCase().includes(keywords)) ||
                                    (person.number && person.number.toString().includes(keywords)) ||
                                    (person.email_address && person.email_address.toLowerCase().includes(keywords)) ||
                                    (person.mobile_phone_number && person.mobile_phone_number.toString().toLowerCase().includes(keywords)) ||
                                    (person.work_phone_number && person.work_phone_number.toString().toLowerCase().includes(keywords)) ||
                                    (person.home_phone_number && person.home_phone_number.toString().toLowerCase().includes(keywords)) ||
                                    (person.organisation?.title && person.organisation?.title.toString().toLowerCase().includes(keywords))
                                ) {
                                    let people = this.visible_people;
                                    people.push(person)
                                    people.sort((a, b) => {
                                        if(a['full_name'].toLowerCase() < b['full_name'].toLowerCase()) { return -1; }
                                        if(a['full_name'].toLowerCase() > b['full_name'].toLowerCase()) { return 1; }
                                        return 0;
                                    });
                                    this.visible_people = people;
                                }
                            }
                            break;
                        }
                    }
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("person_added|person_picker_modal");
        this.observerService.destroy("person_deleted|person_picker_modal");
        this.observerService.destroy("person_updated|person_picker_modal");
    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        if(!this.person) {
            setTimeout(() => {
                if(this.search_bar_input) {
                    this.search_bar_input.setFocus();
                }
            }, 200);
        }
    }

    searchPeople() {
        let keywords = this.keywords.toLowerCase().trim();
        this.people = null;
        if(keywords.length) {
            let people = [];
            for(let i = 0; i < this.all_people.length; i++) {
                if(
                    (this.all_people[i].full_name && this.all_people[i].full_name.toLowerCase().includes(keywords)) ||
                    (this.all_people[i].number && this.all_people[i].number.toString().includes(keywords)) ||
                    (this.all_people[i].email_address && this.all_people[i].email_address.toLowerCase().includes(keywords)) ||
                    (this.all_people[i].mobile_phone_number && this.all_people[i].mobile_phone_number.toString().toLowerCase().includes(keywords)) ||
                    (this.all_people[i].work_phone_number && this.all_people[i].work_phone_number.toString().toLowerCase().includes(keywords)) ||
                    (this.all_people[i].home_phone_number && this.all_people[i].home_phone_number.toString().toLowerCase().includes(keywords)) ||
                    (this.all_people[i].organisation?.title && this.all_people[i].organisation?.title.toString().toLowerCase().includes(keywords))
                ) {
                    if(!this.all_people[i].full_name) {
                        this.all_people[i].full_name = '';
                    }
                    people.push(this.all_people[i]);
                }
            }
            people.sort((a, b) => {
                if(a['full_name'].toLowerCase() < b['full_name'].toLowerCase()) { return -1; }
                if(a['full_name'].toLowerCase() > b['full_name'].toLowerCase()) { return 1; }
                return 0;
            });
            this.people = people;
            this.showInitialVisiblePeople();
        }
        else {
            this.people = [];
        }
    }

    showInitialVisiblePeople() {
        return new Promise<void>((resolve, reject) => {
            this.visible_people = [];
            for(let i = 0; i < 20; i++) {
                if(this.people.length > i) {
                    this.visible_people.push(this.people[i]);
                } 
                else {
                    break;
                }
            }
            resolve();
        });
    }

    showMoreVisiblePeople(event) {
        let count = this.visible_people.length;
        for(let i = 0; i < 20; i++) {
            let position = i + count;
            if(this.people.length > position) {
                this.visible_people.push(this.people[position]);
            } 
            else {
                break;
            }
        }
        event.target.complete();
    }

    loadPerson(person_id) {
        return new Promise((resolve, reject) => {
            this.person = null;
            this.personService.getPerson(person_id).then((person) => {
                if(person) {
                    resolve(person);
                }
            })
            .catch(() => {
                reject();
            });
        });
    }

    clear() {
        this.person = null;
        setTimeout(() => {
            if(this.search_bar_input) {
                this.search_bar_input.setFocus();
            }
        }, 200);
    }

    close() {
        if(this.person_id && !this.person && !this.params["person_id"]) {
            this.params["picker_action"] = "person_deleted";
            this.modalController.dismiss(this.params);
        }
        else if(this.params["person_id"]) {
            this.params["picker_action"] = "person_selected";
            this.modalController.dismiss(this.params);
        }
        else {
            this.modalController.dismiss();
        }
    }

    select(person_id) {

        this.params["person_id"] = person_id;

        for(let i = 0; i < this.people.length; i++) {
            if(this.people[i].id == person_id) {
                if(this.people[i].full_name) {
                    this.params['person_name'] = this.people[i].full_name + ' (#' + this.people[i].number + ')';
                }
                else {
                    this.params['person_name'] = '#' + this.people[i].number;
                }
                break;
            }
        }

        this.close();
    }

    async presentAddPersonModal() {
        const modal = await this.modalController.create({
            component: PersonAddPage,
            componentProps: {
                invoked_from: "person_picker_modal"
            }
        });
        modal.onDidDismiss().then((data) => {
            if(data.data) {
                let person_id = data.data['person_id'];
                this.loadPerson(person_id).then((person) => {
                    this.params["person_id"] = person['id'];
                    if(person['full_name']) {
                        this.params['person_name'] = person['full_name'] + ' (#' + person['number'] + ')';
                    }
                    else {
                        this.params['person_name'] = '#' + person['number'];
                    }
                    this.close();
                })
                .catch(() => { });
            }
        });
        return await modal.present();
    }

}
